function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];

      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }

    return target;
  };
  return _extends.apply(this, arguments);
}

import { h } from 'preact';
import { UIPlugin } from '@uppy/core';
import getFileTypeExtension from '@uppy/utils/lib/getFileTypeExtension';
import ScreenRecIcon from "./ScreenRecIcon.js";
import RecorderScreen from "./RecorderScreen.js";
var packageJson = {
  "version": "3.0.2"
};
import locale from './locale.js'; // Check if screen capturing is supported.
// mediaDevices is supprted on mobile Safari, getDisplayMedia is not

function isScreenRecordingSupported() {
  var _navigator$mediaDevic;

  return window.MediaRecorder && ((_navigator$mediaDevic = navigator.mediaDevices) == null ? void 0 : _navigator$mediaDevic.getDisplayMedia); // eslint-disable-line compat/compat
} // Adapted from: https://developer.mozilla.org/en-US/docs/Web/API/MediaDevices/getUserMedia


function getMediaDevices() {
  return window.MediaRecorder && navigator.mediaDevices; // eslint-disable-line compat/compat
}
/**
 * Screen capture
 */


var ScreenCapture = /*#__PURE__*/function (_UIPlugin) {
  _inherits(ScreenCapture, _UIPlugin);

  var _super = _createSuper(ScreenCapture);

  function ScreenCapture(uppy, opts) {
    var _this;

    _classCallCheck(this, ScreenCapture);

    _this = _super.call(this, uppy, opts);
    _this.mediaDevices = getMediaDevices(); // eslint-disable-next-line no-restricted-globals

    _this.protocol = location.protocol === 'https:' ? 'https' : 'http';
    _this.id = _this.opts.id || 'ScreenCapture';
    _this.title = _this.opts.title || 'Screencast';
    _this.type = 'acquirer';
    _this.icon = ScreenRecIcon;
    _this.defaultLocale = locale; // set default options
    // https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamConstraints

    var defaultOptions = {
      // https://developer.mozilla.org/en-US/docs/Web/API/MediaTrackConstraints#Properties_of_shared_screen_tracks
      displayMediaConstraints: {
        video: {
          width: 1280,
          height: 720,
          frameRate: {
            ideal: 3,
            max: 5
          },
          cursor: 'motion',
          displaySurface: 'monitor'
        }
      },
      // https://developer.mozilla.org/en-US/docs/Web/API/MediaStreamConstraints/audio
      userMediaConstraints: {
        audio: true
      },
      preferredVideoMimeType: 'video/webm'
    }; // merge default options with the ones set by user

    _this.opts = _objectSpread(_objectSpread({}, defaultOptions), opts); // i18n

    _this.i18nInit(); // uppy plugin class related


    _this.install = _this.install.bind(_assertThisInitialized(_this));
    _this.setPluginState = _this.setPluginState.bind(_assertThisInitialized(_this));
    _this.render = _this.render.bind(_assertThisInitialized(_this)); // screen capturer related

    _this.start = _this.start.bind(_assertThisInitialized(_this));
    _this.stop = _this.stop.bind(_assertThisInitialized(_this));
    _this.startRecording = _this.startRecording.bind(_assertThisInitialized(_this));
    _this.stopRecording = _this.stopRecording.bind(_assertThisInitialized(_this));
    _this.submit = _this.submit.bind(_assertThisInitialized(_this));
    _this.streamInterrupted = _this.streamInactivated.bind(_assertThisInitialized(_this)); // initialize

    _this.captureActive = false;
    _this.capturedMediaFile = null;
    return _this;
  }

  _createClass(ScreenCapture, [{
    key: "install",
    value: function install() {
      if (!isScreenRecordingSupported()) {
        this.uppy.log('Screen recorder access is not supported', 'warning');
        return null;
      }

      this.setPluginState({
        streamActive: false,
        audioStreamActive: false
      });
      var target = this.opts.target;

      if (target) {
        this.mount(target, this);
      }

      return undefined;
    }
  }, {
    key: "uninstall",
    value: function uninstall() {
      if (this.videoStream) {
        this.stop();
      }

      this.unmount();
    }
  }, {
    key: "start",
    value: function start() {
      var _this2 = this;

      if (!this.mediaDevices) {
        return Promise.reject(new Error('Screen recorder access not supported'));
      }

      this.captureActive = true;
      this.selectAudioStreamSource();
      return this.selectVideoStreamSource().then(function (res) {
        // something happened in start -> return
        if (res === false) {
          // Close the Dashboard panel if plugin is installed
          // into Dashboard (could be other parent UI plugin)
          if (_this2.parent && _this2.parent.hideAllPanels) {
            _this2.parent.hideAllPanels();

            _this2.captureActive = false;
          }
        }
      });
    }
  }, {
    key: "selectVideoStreamSource",
    value: function selectVideoStreamSource() {
      var _this3 = this;

      // if active stream available, return it
      if (this.videoStream) {
        return new Promise(function (resolve) {
          return resolve(_this3.videoStream);
        });
      } // ask user to select source to record and get mediastream from that
      // eslint-disable-next-line compat/compat


      return this.mediaDevices.getDisplayMedia(this.opts.displayMediaConstraints).then(function (videoStream) {
        _this3.videoStream = videoStream; // add event listener to stop recording if stream is interrupted

        _this3.videoStream.addEventListener('inactive', function () {
          _this3.streamInactivated();
        });

        _this3.setPluginState({
          streamActive: true
        });

        return videoStream;
      }).catch(function (err) {
        _this3.setPluginState({
          screenRecError: err
        });

        _this3.userDenied = true;
        setTimeout(function () {
          _this3.userDenied = false;
        }, 1000);
        return false;
      });
    }
  }, {
    key: "selectAudioStreamSource",
    value: function selectAudioStreamSource() {
      var _this4 = this;

      // if active stream available, return it
      if (this.audioStream) {
        return new Promise(function (resolve) {
          return resolve(_this4.audioStream);
        });
      } // ask user to select source to record and get mediastream from that
      // eslint-disable-next-line compat/compat


      return this.mediaDevices.getUserMedia(this.opts.userMediaConstraints).then(function (audioStream) {
        _this4.audioStream = audioStream;

        _this4.setPluginState({
          audioStreamActive: true
        });

        return audioStream;
      }).catch(function (err) {
        if (err.name === 'NotAllowedError') {
          _this4.uppy.info(_this4.i18n('micDisabled'), 'error', 5000);

          _this4.uppy.log(_this4.i18n('micDisabled'), 'warning');
        }

        return false;
      });
    }
  }, {
    key: "startRecording",
    value: function startRecording() {
      var _this5 = this;

      var options = {};
      this.capturedMediaFile = null;
      this.recordingChunks = [];
      var preferredVideoMimeType = this.opts.preferredVideoMimeType;
      this.selectVideoStreamSource().then(function (videoStream) {
        // Attempt to use the passed preferredVideoMimeType (if any) during recording.
        // If the browser doesn't support it, we'll fall back to the browser default instead
        if (preferredVideoMimeType && MediaRecorder.isTypeSupported(preferredVideoMimeType) && getFileTypeExtension(preferredVideoMimeType)) {
          options.mimeType = preferredVideoMimeType;
        } // prepare tracks


        var tracks = [videoStream.getVideoTracks()[0]]; // merge audio if exits

        if (_this5.audioStream) {
          tracks.push(_this5.audioStream.getAudioTracks()[0]);
        } // create new stream from video and audio
        // eslint-disable-next-line compat/compat


        _this5.outputStream = new MediaStream(tracks); // initialize mediarecorder
        // eslint-disable-next-line compat/compat

        _this5.recorder = new MediaRecorder(_this5.outputStream, options); // push data to buffer when data available

        _this5.recorder.addEventListener('dataavailable', function (event) {
          _this5.recordingChunks.push(event.data);
        }); // start recording


        _this5.recorder.start(); // set plugin state to recording


        _this5.setPluginState({
          recording: true
        });
      }).catch(function (err) {
        _this5.uppy.log(err, 'error');
      });
    }
  }, {
    key: "streamInactivated",
    value: function streamInactivated() {
      // get screen recorder state
      var _this$getPluginState = _objectSpread({}, this.getPluginState()),
          recordedVideo = _this$getPluginState.recordedVideo,
          recording = _this$getPluginState.recording;

      if (!recordedVideo && !recording) {
        // Close the Dashboard panel if plugin is installed
        // into Dashboard (could be other parent UI plugin)
        if (this.parent && this.parent.hideAllPanels) {
          this.parent.hideAllPanels();
        }
      } else if (recording) {
        // stop recorder if it is active
        this.uppy.log('Capture stream inactive — stop recording');
        this.stopRecording();
      }

      this.videoStream = null;
      this.audioStream = null;
      this.setPluginState({
        streamActive: false,
        audioStreamActive: false
      });
    }
  }, {
    key: "stopRecording",
    value: function stopRecording() {
      var _this6 = this;

      var stopped = new Promise(function (resolve) {
        _this6.recorder.addEventListener('stop', function () {
          resolve();
        });

        _this6.recorder.stop();
      });
      return stopped.then(function () {
        // recording stopped
        _this6.setPluginState({
          recording: false
        }); // get video file after recorder stopped


        return _this6.getVideo();
      }).then(function (file) {
        // store media file
        _this6.capturedMediaFile = file; // create object url for capture result preview

        _this6.setPluginState({
          // eslint-disable-next-line compat/compat
          recordedVideo: URL.createObjectURL(file.data)
        });
      }).then(function () {
        _this6.recordingChunks = null;
        _this6.recorder = null;
      }, function (error) {
        _this6.recordingChunks = null;
        _this6.recorder = null;
        throw error;
      });
    }
  }, {
    key: "submit",
    value: function submit() {
      try {
        // add recorded file to uppy
        if (this.capturedMediaFile) {
          this.uppy.addFile(this.capturedMediaFile);
        }
      } catch (err) {
        // Logging the error, exept restrictions, which is handled in Core
        if (!err.isRestriction) {
          this.uppy.log(err, 'warning');
        }
      }
    }
  }, {
    key: "stop",
    value: function stop() {
      // flush video stream
      if (this.videoStream) {
        this.videoStream.getVideoTracks().forEach(function (track) {
          track.stop();
        });
        this.videoStream.getAudioTracks().forEach(function (track) {
          track.stop();
        });
        this.videoStream = null;
      } // flush audio stream


      if (this.audioStream) {
        this.audioStream.getAudioTracks().forEach(function (track) {
          track.stop();
        });
        this.audioStream.getVideoTracks().forEach(function (track) {
          track.stop();
        });
        this.audioStream = null;
      } // flush output stream


      if (this.outputStream) {
        this.outputStream.getAudioTracks().forEach(function (track) {
          track.stop();
        });
        this.outputStream.getVideoTracks().forEach(function (track) {
          track.stop();
        });
        this.outputStream = null;
      } // remove preview video


      this.setPluginState({
        recordedVideo: null
      });
      this.captureActive = false;
    }
  }, {
    key: "getVideo",
    value: function getVideo() {
      var mimeType = this.recordingChunks[0].type;
      var fileExtension = getFileTypeExtension(mimeType);

      if (!fileExtension) {
        return Promise.reject(new Error("Could not retrieve recording: Unsupported media type \"".concat(mimeType, "\"")));
      }

      var name = "screencap-".concat(Date.now(), ".").concat(fileExtension);
      var blob = new Blob(this.recordingChunks, {
        type: mimeType
      });
      var file = {
        source: this.id,
        name: name,
        data: new Blob([blob], {
          type: mimeType
        }),
        type: mimeType
      };
      return Promise.resolve(file);
    }
  }, {
    key: "render",
    value: function render() {
      // get screen recorder state
      var recorderState = this.getPluginState();

      if (!recorderState.streamActive && !this.captureActive && !this.userDenied) {
        this.start();
      }

      return h(RecorderScreen, _extends({}, recorderState, {
        // eslint-disable-line react/jsx-props-no-spreading
        onStartRecording: this.startRecording,
        onStopRecording: this.stopRecording,
        onStop: this.stop,
        onSubmit: this.submit,
        i18n: this.i18n,
        stream: this.videoStream
      }));
    }
  }]);

  return ScreenCapture;
}(UIPlugin);

export { ScreenCapture as default };
ScreenCapture.VERSION = packageJson.version;